import React from "react"
import DataTable from "react-data-table-component"
import { customStyles } from "constants/layout"
import { textosPaginacion } from "components/Tables/paginacion"

const DataTableComponent = ({
  data,
  columns,
  styles,
  dense,
  pagination,
  noDataComponent,
  subHeader,
  subHeaderComponent,
  noHeader,
  conditionalRowStyles,
  selectableRows,
  actions,
  disabled,
  showAll,
}) => {
  const paginationComponentOptions = {
    ...textosPaginacion,
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  }

  const rowCount = data?.length || 0

  return (
    <DataTable
      key={showAll ? rowCount : undefined}
      columns={columns}
      data={data}
      customStyles={styles || customStyles}
      dense={dense == false ? false : true}
      pagination={pagination == false ? false : data?.length > 10}
      paginationComponentOptions={paginationComponentOptions}
      paginationPerPage={showAll ? rowCount || 9999 : undefined}
      paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
      conditionalRowStyles={conditionalRowStyles}
      noDataComponent={noDataComponent || "No hay información para mostrar"}
      subHeader={subHeader || false}
      subHeaderComponent={subHeaderComponent}
      subHeaderAlign={"left"}
      noHeader={noHeader || false}
      selectableRows={selectableRows || false}
      actions={actions || null}
      disabled={disabled || false}
    />
  )
}

export default DataTableComponent
